import classNames from "classnames";
import CiroPill from "../shared/CiroPill";
import { OpensearchCuratedSearch } from "../../__generated__/graphql";

export const HeaderPill = ({ text }: { text: string }) => (
  <CiroPill background="bg-orange-100" fontColor="text-orange-500">
    {text}
  </CiroPill>
);

const CuratedSearchFiltersHeaderDisplay = ({
  savedFilters,
}: {
  savedFilters: OpensearchCuratedSearch | null;
}) => {
  return (
    <div
      className={classNames(
        "overflow-hidden",
        "text-ellipsis",
        "whitespace-nowrap",
        "truncate",
        "flex",
        "items-center",
        "gap-1",
        "text-xs",
        "text-neutral-500",
        "shrink",
        "pr-8",
        "bg-gradient-to-r",
        "from-current",
        "via-current",
        "to-transparent",
        "bg-clip-text",
        "[mask-image:linear-gradient(to_right,black_75%,transparent)]",
      )}
    >
      {savedFilters?.opensearchFiltersBlob
        ? "Filters Applied"
        : "No Filters Applied"}
    </div>
  );
};

export default CuratedSearchFiltersHeaderDisplay;
